module.exports = __webpack_public_path__ + "static/media/react-companies-logo-transparent.44448c2e.svg";